module.exports = new __parcel__URL__("auto-sai_QR.3e455f0e.png").toString();